import { Component, OnInit, Input } from '@angular/core';
import { InvoiceService } from '../../../../shared/services/invoice.service';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-add-invoice-item',
  templateUrl: './add-invoice-item.component.html',
  styleUrls: ['./add-invoice-item.component.scss']
})
export class AddInvoiceItemComponent implements OnInit {

  @Input() invoiceId: number;
  @Input() caseId: number;
  @Input() feeType: number = 1;
    
  fees: any[] = [];
  selectedItem: any;
  feeTypes: any = [];
  feeTypeName: string = "Professional Charge";

  newInvoiceItemDetails = this.fb.group({
    feeType: [],
    description: ['', Validators.required],
    net: [null, Validators.required],
    addVat: false,
    outlayId: null,
    nominalCode: null,
    feeId: null
  }, { });

  constructor(private invoiceService: InvoiceService,
              public activeModal: NgbActiveModal,
              private fb: UntypedFormBuilder)
  {


  }

  ngOnInit(): void {
      this.newInvoiceItemDetails.controls["feeType"].patchValue(this.feeType);
      this.loadFees();
  }

  loadFees(){

    // Set the title based on the API enum description
    this.invoiceService.getFeeTypes().subscribe((response : any) => {      
      this.feeTypes = response;
      this.feeTypeName = this.feeTypes.filter(x => x.key == this.feeType)[0].value;
    });
    
    this.invoiceService.getFeeTypesForCase( this.caseId, this.feeType).subscribe((response : any) => {
      this.fees = response.fees;
    });
  }

  addInvoiceItem(){
    this.invoiceService.addInvoiceItem( this.caseId, this.invoiceId, this.newInvoiceItemDetails.value ).subscribe((response : any) => {
      this.activeModal.close(true);
    });
  }

  feeChange(){
    this.newInvoiceItemDetails.controls["description"].patchValue(this.selectedItem.description);
    this.newInvoiceItemDetails.controls["net"].patchValue(this.selectedItem.net);
    this.newInvoiceItemDetails.controls["addVat"].patchValue(this.selectedItem.includeVAT);
    this.newInvoiceItemDetails.controls["feeId"].patchValue(this.selectedItem.id);
  }
}
